// src/components/Contact/Contact.js
import React from 'react';
import MainLayout from '../Layout/MainLayout';
import './Contact.css';

const Contact = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/554137984531', '_blank');
  };

  const handleEmailClick = () => {
    window.open('mailto:adm@drepro.com.br', '_blank');
  };

  const copyToClipboard = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      // You could add a toast notification here
      console.log(`${type} copiado para a área de transferência`);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
  };

  return (
    <MainLayout>
      <div className="contact-container">
        {/* Header */}
        <div className="contact-header">
          <h1>Entre em Contato</h1>
          <p>Estamos aqui para ajudar com suas dúvidas e suporte técnico</p>
        </div>

        {/* Contact Cards - Grid 2x2 */}
        <div className="contact-cards">
          {/* WhatsApp Card */}
          <div className="contact-card whatsapp-card">
            <div className="contact-icon">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.488"/>
              </svg>
            </div>
            
            <div className="contact-info">
              <h3>WhatsApp</h3>
              <p className="contact-description">Suporte rápido via mensagem</p>
              <div className="contact-value">+55 41 3798-4531</div>
            </div>

            <div className="contact-actions">
              <button 
                className="contact-btn primary"
                onClick={handleWhatsAppClick}
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.488"/>
                </svg>
                Enviar Mensagem
              </button>
              
              <button 
                className="contact-btn secondary"
                onClick={() => copyToClipboard('+5541979844531', 'WhatsApp')}
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copiar
              </button>
            </div>
          </div>

          {/* Email Card */}
          <div className="contact-card email-card">
            <div className="contact-icon">
              <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            
            <div className="contact-info">
              <h3>E-mail</h3>
              <p className="contact-description">Suporte técnico e comercial</p>
              <div className="contact-value">adm@drepro.com.br</div>
            </div>

            <div className="contact-actions">
              <button 
                className="contact-btn primary"
                onClick={handleEmailClick}
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                Enviar E-mail
              </button>
              
              <button 
                className="contact-btn secondary"
                onClick={() => copyToClipboard('adm@drepro.com.br', 'E-mail')}
              >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copiar
              </button>
            </div>
          </div>

          {/* Support Information Cards */}
          <div className="support-info">
            {/* Como podemos ajudar? Card */}
            <div className="support-card">
              <div className="support-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <circle cx="12" cy="17" r="0.01"></circle>
                </svg>
              </div>
              <div className="support-content">
                <h3>Como podemos ajudar?</h3>
                <ul>
                  <li>Dúvidas sobre upload de arquivos OFX</li>
                  <li>Problemas com categorização de transações</li>
                  <li>Configuração de categorias personalizadas</li>
                  <li>Suporte técnico geral</li>
                </ul>
              </div>
            </div>

            {/* Horário de Atendimento Card */}
            <div className="support-card">
              <div className="support-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12,6 12,12 16,14"></polyline>
                </svg>
              </div>
              <div className="support-content">
                <h3>Horário de Atendimento</h3>
                <p><strong>Segunda a Sexta:</strong> 9h às 18h</p>
                <p><strong>Sábado:</strong> 9h às 12h</p>
                <p><strong>Domingo:</strong> Não atendemos</p>
                <p className="response-time">⚡ Resposta em até 2 horas durante o horário comercial</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Contact;